/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IObrienProductVideoData } from './obrien-product-video.data';
import { IObrienProductVideoProps } from './obrien-product-video.props.autogenerated';

export interface IObrienProductVideoViewProps extends IObrienProductVideoProps<IObrienProductVideoData> {

    photo: React.ReactNode;
    videoUrl: string;

}

/**
 *
 * ObrienProductVideo component
 * @extends {React.PureComponent<IObrienProductVideoProps<IObrienProductVideoData>>}
 */
class ObrienProductVideo extends React.PureComponent<IObrienProductVideoProps<IObrienProductVideoData>> {
    public render(): JSX.Element | null {

        const { 
            photo,
            videoUrl
        } = this.props.config;

        const VideoUrl = videoUrl ? videoUrl : 'No Link';

        const imageOneProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: photo && photo.imageSettings,
        };

        const Photo = photo && (
            <Msdyn365.Image {...photo} {...imageOneProps} editProps ={{key:this.props.config.photo || {}, requestContext: this.props.context.request}}/>
        );

        const ObrienProductVideo = {
            ...this.props,
            
            photo: Photo,
            videoUrl: VideoUrl
            
            
        };

        return this.props.renderView(ObrienProductVideo);
    }
}

export default ObrienProductVideo;
